import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { LeftNavDataProvider } from '@ocm_customer/account_navigation';
import { ThemeProvider } from '@material-ui/core';
import { useReturnStore } from './stores/returnStore';
import CommonProvider from './contexts/CommonContext';
import { Error } from './pages/Error';
import { getRoutes } from './routes.js';
import { THDTheme } from './theme/theme';
import Spinner from './components/shared/Spinner';
import { redirectToSignIn } from './utils/http-helper';
import './styles/app.scss';
import useReturnSession from './hooks/useReturnSession';
export var App = function (_a) {
    var customerType = _a.customerType, customerRole = _a.customerRole, _b = _a.policyData, policyData = _b === void 0 ? null : _b, _c = _a.trialsData, trialsData = _c === void 0 ? null : _c, _d = _a.enrollmentsData, enrollmentsData = _d === void 0 ? null : _d, _e = _a.userData, userData = _e === void 0 ? null : _e;
    // will call to get the return session data globally and only once
    useReturnSession();
    var instance = useContext(AppContext).instance;
    var _f = instance.router, currentRouteName = _f.currentRouteName, currentRouteComponent = _f.currentRouteComponent;
    var routes = getRoutes(currentRouteName, currentRouteComponent);
    var isLoggedIn = useThdCustomer().isLoggedIn;
    var orderDetails = useReturnStore(function (state) { return state.orderDetailsV2; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    React.useEffect(function () {
        // Check for orderdetails data to see if data has been loaded & isMilitaryExchangeGuest has been retrieved.
        // If guest is false, user has to be logged in. Otherwise, no need to check session.
        if (orderDetails) {
            if (!isMilitaryExchangeGuest) {
                if (!isLoggedIn && currentRouteName !== 'home') {
                    redirectToSignIn();
                }
            }
        }
    }, [currentRouteName, isMilitaryExchangeGuest, orderDetails]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LeftNavDataProvider, { defaultPolicyData: policyData, defaultTrialsData: trialsData, defaultUserData: userData, defaultEnrollmentData: enrollmentsData },
            React.createElement(ThemeProvider, { theme: THDTheme },
                React.createElement(CommonProvider, null,
                    React.createElement(React.Fragment, null,
                        React.createElement(Routes, null,
                            React.createElement(Route, { exact: true, path: routes.returns.path, element: React.createElement(routes.returns.component, { customerType: customerType, customerRole: customerRole }) }),
                            React.createElement(Route, { exact: true, path: routes.returnSummary.path, element: React.createElement(routes.returnSummary.component, { customerType: customerType, customerRole: customerRole }) }),
                            React.createElement(Route, { exact: true, path: routes.home.path, element: React.createElement(routes.home.component, null) }),
                            React.createElement(Route, { path: "/error", element: React.createElement(Error, null) }),
                            React.createElement(Route, { element: React.createElement(Error, null) })),
                        React.createElement(Spinner, null))))),
        React.createElement(ScrollToTop, null)));
};
App.propTypes = {};
App.defaultProps = {};
